import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "min-w-0 truncate" }
const _hoisted_4 = {
  "data-test": "product-name",
  class: "font-medium"
}
const _hoisted_5 = {
  key: 0,
  "data-test": "no-results",
  class: "px-3 py-3 text-sm text-gray-500"
}

import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions } from '@headlessui/vue'
import { CheckIcon, MagnifyingGlassIcon } from '@heroicons/vue/20/solid'
import { onUnmounted, ref } from 'vue'

import BasicSpinner from '@/components/BasicSpinner.vue'
import api from '@/store/api'
import { mapRelationships } from '@/store/mappers'

// Same pause as the global search palette before a request goes out
const SEARCH_DEBOUNCE_MS = 500


export default {
  __name: 'ProductSearchPicker',
  props: {
  modelValue: { type: Array, default: () => [] },
  placeholder: { type: String, default: 'Search products...' }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {


const emit = __emit

const query = ref('')
const results = ref([])
const pending = ref(false)
let debounceTimer
let controller

const abandonSearch = () => {
  clearTimeout(debounceTimer)
  controller?.abort()
}

const ignoreAbort = e => {
  if (e.name !== 'AbortError') throw e
}

const runSearch = () => {
  controller = new AbortController()
  return api
    .call('POST', 'products/search', { search: { text: query.value } }, { save: false, abortController: controller })
    .then(response => {
      results.value = response.data.data
      pending.value = false
    })
    .catch(ignoreAbort)
}

const onInput = text => {
  query.value = text
  abandonSearch()
  if (!text) {
    results.value = []
    pending.value = false
    return
  }
  pending.value = true
  debounceTimer = setTimeout(runSearch, SEARCH_DEBOUNCE_MS)
}

const image = product => mapRelationships(product.relationships?.attachments?.data ?? [])[0]?.attributes.secure_url

onUnmounted(abandonSearch)

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(Combobox), {
    as: "div",
    "model-value": __props.modelValue,
    multiple: "",
    by: "id",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = selection => emit('update:modelValue', selection))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createVNode(_unref(MagnifyingGlassIcon), {
          class: "pointer-events-none absolute top-2.5 left-3 h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }, null, 512), [
          [_vShow, !pending.value]
        ]),
        _withDirectives(_createVNode(BasicSpinner, {
          class: "pointer-events-none absolute top-2.5 left-3",
          color: "text-gray-500",
          "aria-hidden": "true"
        }, null, 512), [
          [_vShow, pending.value]
        ]),
        _createVNode(_unref(ComboboxInput), {
          class: "block w-full rounded border-gray-300 pl-10 pr-4 text-gray-800 placeholder-gray-400 focus:border-blue-500 focus:ring-blue-500 sm:text-sm",
          autocomplete: "off",
          placeholder: __props.placeholder,
          "display-value": () => query.value,
          onChange: _cache[0] || (_cache[0] = e => onInput(e.target.value))
        }, null, 8, ["placeholder", "display-value"])
      ]),
      _withDirectives(_createVNode(_unref(ComboboxOptions), {
        static: "",
        class: "mt-2 max-h-60 overflow-y-auto rounded-md border border-gray-200 py-1 text-sm text-gray-800"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (product) => {
            return (_openBlock(), _createBlock(_unref(ComboboxOption), {
              key: product.id,
              as: "template",
              value: product
            }, {
              default: _withCtx(({ active, selected }) => [
                _createElementVNode("li", {
                  class: _normalizeClass([
            'flex cursor-pointer select-none items-center gap-2 px-3 py-2',
            active ? 'bg-brand-600 text-white' : selected && 'text-gray-400'
          ])
                }, [
                  (image(product))
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "h-8 w-8 flex-shrink-0 rounded object-cover",
                        src: image(product)
                      }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(product.attributes.product_name), 1),
                    (product.attributes.description)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["ml-1 text-xs", active ? 'text-gray-200' : 'text-gray-500'])
                        }, _toDisplayString(product.attributes.description), 3))
                      : _createCommentVNode("", true)
                  ]),
                  selected
                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                        key: 1,
                        class: "ml-auto h-4 w-4 flex-shrink-0",
                        "aria-hidden": "true"
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, query.value.length && results.value.length]
      ]),
      (query.value.length && !pending.value && !results.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, " No results found "))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

}